import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="max-w-2xl mx-auto text-center space-y-8">
      {/* 404 Icon */}
      <div className="flex justify-center">
        <div className="p-6 bg-gray-100 rounded-full">
          <Search className="text-gray-400" size={64} />
        </div>
      </div>

      {/* Error Message */}
      <div>
        <h1 className="text-6xl font-bold text-gray-900 mb-4">
          404
        </h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Page Not Found
        </h2>
        <p className="text-lg text-gray-600 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved. 
          Let's get you back to translating!
        </p>
      </div>

      {/* Navigation Options */}
      <div className="space-y-4">
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="btn-primary flex items-center justify-center space-x-2"
          >
            <Home size={16} />
            <span>Back to Home</span>
          </Link>
          
          <Link
            to="/translate"
            className="btn-secondary flex items-center justify-center space-x-2"
          >
            <ArrowLeft size={16} />
            <span>Start Translating</span>
          </Link>
        </div>
      </div>

      {/* Helpful Links */}
      <div className="card bg-gray-50">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Try one of these instead:
        </h3>
        <div className="grid sm:grid-cols-2 gap-3 text-left">
          <Link 
            to="/instructions" 
            className="p-3 bg-white rounded border hover:border-primary-300 transition-colors"
          >
            <div className="font-medium text-gray-900">Instructions</div>
            <div className="text-sm text-gray-600">Learn how to use Sranslate™</div>
          </Link>
          
          <Link 
            to="/about" 
            className="p-3 bg-white rounded border hover:border-primary-300 transition-colors"
          >
            <div className="font-medium text-gray-900">About</div>
            <div className="text-sm text-gray-600">Learn about our mission</div>
          </Link>
          
          <Link 
            to="/faq" 
            className="p-3 bg-white rounded border hover:border-primary-300 transition-colors"
          >
            <div className="font-medium text-gray-900">FAQ</div>
            <div className="text-sm text-gray-600">Common questions answered</div>
          </Link>
          
          <a 
            href="mailto:info@sranslate.nl?subject=Sranslate%20Support" 
            className="p-3 bg-white rounded border hover:border-primary-300 transition-colors"
          >
            <div className="font-medium text-gray-900">Contact</div>
            <div className="text-sm text-gray-600">Get in touch with us</div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;